/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FilterAddIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Filter Add',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden="${hidden ? 'true' : 'false'}"
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.8 27a13.146 13.146 0 013.2-8.411C20.083 15.9 29.733 3.617 29.733 3.617A1 1 0 0028.946 2H1.054a1 1 0 00-.787 1.617L12 18.589V33.9a.992.992 0 001.68.825l2.338-2.439A12.131 12.131 0 0114.8 27z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 108.9 8.9 8.9 8.9 0 00-8.9-8.9zm5 9.4a.5.5 0 01-.5.5H28v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V28h-3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H26v-3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V26h3.5a.5.5 0 01.5.5z"
    />
  </svg>`;
};
